export default "/assets/images/logo.svg?b60848e51dc26ae2299e742c86a21c7a";